import React, { useState, useEffect } from 'react';
import { CharacterAppearance } from '../types';

interface CharacterDisplayProps {
  appearance: CharacterAppearance;
  isActive: boolean;
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

export const CharacterDisplay: React.FC<CharacterDisplayProps> = ({
  appearance,
  isActive,
  width = 80,
  height = 120,
  className,
  style
}) => {
  const [currentImage, setCurrentImage] = useState(appearance.idle);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    setCurrentImage(isActive ? appearance.active : appearance.idle);
    setImageError(false);
  }, [isActive, appearance]);

  const handleImageError = () => {
    setImageError(true);
  };

  if (imageError) {
    // 如果图片加载失败，显示占位符
    return (
      <div 
        style={{
          width: `${width}px`,
          height: `${height}px`,
          backgroundColor: '#8B4513',
          borderRadius: '8px',
          border: '3px solid #654321',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...style
        }}
        className={className}
      >
        <div style={{
          color: '#fff',
          fontSize: '12px',
          fontWeight: 'bold',
          textAlign: 'center'
        }}>
          {isActive ? '攻击中' : '待机'}
        </div>
      </div>
    );
  }

  return (
    <img
      src={currentImage}
      alt={isActive ? 'Active Character' : 'Idle Character'}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        objectFit: 'contain',
        ...style
      }}
      className={className}
      onError={handleImageError}
    />
  );
};